import React from 'react';
import { COMPARED_OPTIONS } from '~/config/constants';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

function InlineEditingCell({ row, editedRow, handleChange, fieldName, tag }) {
    switch (tag) {
        case 'input':
            if (row.id !== editedRow.id) {
                return row[fieldName];
            } else {
                return (
                    <input
                        value={editedRow[fieldName]}
                        style={{ width: '50px' }}
                        onChange={(e) => {
                            handleChange(e, row, fieldName);
                        }}
                    />
                );
            }

        case 'select':
            if (row.id !== editedRow.id) {
                const select = COMPARED_OPTIONS.find((item) => item.id === parseInt(row[fieldName]));

                return select.name;
            } else {
                return (
                    <Form.Control
                        as={'select'}
                        custom
                        onChange={(e) => {
                            handleChange(e, row, fieldName);
                        }}
                        value={editedRow[fieldName]}
                        style={{ fontSize: '0.6rem' }}
                    >
                        {COMPARED_OPTIONS.map((option, i) => {
                            return (
                                <option
                                    value={option.id}
                                    key={i}
                                >
                                    {option.name}
                                </option>
                            );
                        })}
                    </Form.Control>
                );
            }
        default:
            throw new Error('invalid tag name');
    }
}

InlineEditingCell.propTypes = {
    row: PropTypes.object.isRequired,
    editedRow: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
    tag: PropTypes.string.isRequired,
};

export default InlineEditingCell;
